import { render, staticRenderFns } from "./TableFullScreenMessage.vue?vue&type=template&id=0f07e600&scoped=true"
import script from "./TableFullScreenMessage.vue?vue&type=script&lang=js"
export * from "./TableFullScreenMessage.vue?vue&type=script&lang=js"
import style0 from "./TableFullScreenMessage.vue?vue&type=style&index=0&id=0f07e600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07e600",
  null
  
)

export default component.exports